((app, ng) => {

    app.component("figDataTable",
        {
            templateUrl: "/App/DataTable/data-table.html",
            controller: dataTableController,
            bindings: {
                options: "<"
            }
        });

    function dataTableController($cookies, $timeout, $state) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.currentState = $state.$current.name;
            // get stored page and pageSize cookie
            $ctrl.statePageCookie = $cookies.get(`${$ctrl.currentState}_page`);
            $ctrl.statePageSize = $cookies.get(`${$ctrl.currentState}_pageSize`);
            $ctrl.pageSizes = [25, 50, 75, 100];
            $ctrl.pageSize =  $ctrl.statePageSize ? parseInt($ctrl.statePageSize) : $ctrl.pageSizes[0];
            $ctrl.currentPage = parseInt($ctrl.statePageCookie ? $ctrl.statePageCookie : 0);
            $ctrl.tableDensity = "list";
            $ctrl.totalSelectedFilters = 0;
            const filtersJson = $cookies.get(`${$ctrl.options.title.toLowerCase()}_filters`);

            if (!!filtersJson) {
                $ctrl.options.filters = JSON.parse(filtersJson);

                $ctrl.options.filters.forEach(filter => {
                    filter.options.forEach(option => {
                        if (option.selected) {
                            $ctrl.totalSelectedFilters++;
                        }
                    });
                });
            }

            $ctrl.sortRows();
        };
        
        const toggleFilterList = () => {
            $ctrl.ui.filterListIsOpen = !$ctrl.ui.filterListIsOpen;
        };
        
        const sortRows = (columnIndex = 0) => {
            if ($ctrl.sortIndex !== columnIndex) {
                $ctrl.sortIndex = columnIndex;
                $ctrl.reverseSort = false;
            } else {
                $ctrl.reverseSort = !$ctrl.reverseSort;
            }

            $ctrl.options.rows.sort((a, b) => {
                if (a.cells[columnIndex] < b.cells[columnIndex]) return -1;

                if (a.cells[columnIndex] > b.cells[columnIndex]) return 1;

                return 0;
            });

            if ($ctrl.reverseSort) {
                $ctrl.options.rows.reverse();
            }
        };

        const createCsv = (headers, rows) => {
            let csvContent = "data:text/csv;charset=utf-8,";

            const headersStr = headers.map(header => header.title).join(",");

            csvContent = `${csvContent}${headersStr}\r\n`;

            [...rows].forEach(row => {
                row = row.map(cell => {
                    if (typeof cell === "string" && cell.indexOf(",") !== -1) {
                        return cell.replace(/, /g, "/");
                    }

                    return cell;
                });

                const cellsStr = row.join(",");

                csvContent = `${csvContent}${cellsStr}\r\n`;
            });

            return csvContent;
        };

        const downloadCsv = () => {
            const csvContent = createCsv($ctrl.options.headers, $ctrl.options.rows.map(row => row.cells));

            const encodedUri = encodeURI(csvContent);

            const link = document.createElement("a");

            link.href = encodedUri;

            link.download = "untitled.csv";

            link.style = "display:none";

            document.body.appendChild(link);

            link.click();

            $timeout(() => {
                document.body.removeChild(link);
            },
                100);
        };

        const getTotalNumberOfPages = (totalAmountOfRows, pageSize) => {
            return Math.ceil(totalAmountOfRows / pageSize);
        };

        $ctrl.onFilterSelected = (filter) => {
            if (filter.selected) {
                $ctrl.totalSelectedFilters++;
            } else {
                $ctrl.totalSelectedFilters--;
            }

            const cookieName = `${$ctrl.options.title.toLowerCase()}_filters`;

            if ($ctrl.totalSelectedFilters === 0) {
                $cookies.remove(cookieName);
            } else {
                $cookies.put(cookieName, JSON.stringify(this.options.filters));
            }
        };

        $ctrl.resetFilters = (filters) => {
            filters.forEach(filter => {
                filter.options.forEach(option => {
                    option.selected = false;
                });
            });

            $ctrl.totalSelectedFilters = 0;

            $cookies.remove(`${$ctrl.options.title.toLowerCase()}_filters`);
        };

        $ctrl.storePageCookies = () => {
            $cookies.put(`${$ctrl.currentState}_page`, $ctrl.currentPage);
            $cookies.put(`${$ctrl.currentState}_pageSize`, $ctrl.pageSize);
        };

        ng.extend($ctrl,
            {
                ui:{
                    displayFilters: false,
                    filterListIsOpen: false
                },
                sortRows,
                downloadCsv,
                getTotalNumberOfPages,
                toggleFilterList: toggleFilterList
            });

        $ctrl.$onDestroy = () => {
            // if toState is client, then save the page number from the dataTable
            // else remove cookie
            if ($state.$current.name === 'Home.Client.Activity') {
                $cookies.put(`${$ctrl.currentState}_page`, $ctrl.currentPage);
                $cookies.put(`${$ctrl.currentState}_pageSize`, $ctrl.pageSize);
            } else {
                $cookies.remove(`${$ctrl.currentState}_page`);
                $cookies.remove(`${$ctrl.currentState}_pageSize`);
            }
        };
    }

})(window.app, window.angular); 